import styled from 'styled-components'
import type { CallToAction } from './empty-screen.types'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: var(--tds-spacing-element-16);
`

export const IconWrapper = styled.div`
  align-items: start;
  display: flex;
  margin-right: var(--tds-spacing-element-16);
  tds-icon {
    width: 24px;
    height: 24px;
  }
`

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const Title = styled.h1.attrs({
  className: 'tds-headline-04'
})`
  margin: 0;
`

export const Description = styled.p.attrs({
  className: 'tds-body-01'
})`
  margin: 0;
  margin-top: var(--tds-spacing-element-16);
`

export const ActionWrapper = styled.div<Pick<CallToAction, 'type'>>`
  margin-top: ${({ type }) =>
    type === 'link'
      ? 'var(--tds-spacing-element-16)'
      : 'var(--tds-spacing-element-48)'};
`
